import Resource from '@/api/resource';

const baseUrl = 'tracabilite';

export default {
  /**
   * Recherche descendante
   * @param {Object} params - { mode, q, date_debut, date_fin, campagne_id, groupement_id, producteur_id }
   */
  searchDescendante(params) {
    const resource = new Resource(baseUrl + '/descendante');
    return resource.list(params);
  },

  /**
   * Sacs d'un lot
   * @param {Number} lotId
   */
  getSacsDuLot(lotId) {
    const resource = new Resource(baseUrl + '/descendante/lot');
    return resource.get(lotId + '/sacs');
  },

  /**
   * Producteurs d'un lot
   * @param {Number} lotId
   */
  getProducteursDuLot(lotId) {
    const resource = new Resource(baseUrl + '/descendante/lot');
    return resource.get(lotId + '/producteurs');
  },

  /**
   * Parcelles d'un lot (avec GPS)
   * @param {Number} lotId
   */
  getParcellesDuLot(lotId) {
    const resource = new Resource(baseUrl + '/descendante/lot');
    return resource.get(lotId + '/parcelles');
  },

  /**
   * Recherche ascendante
   * @param {Object} params - { producteur_id, parcelle_id, campagne_id, date_debut, date_fin, limit, offset }
   */
  searchAscendante(params) {
    const resource = new Resource(baseUrl + '/ascendante');
    return resource.list(params);
  },
};
